import React from 'react'
import { IIconProps } from './IIconProps'

interface IProps extends IIconProps {
  // Sorted columns show only the active direction; unsorted ones show both
  direction?: 'up' | 'down'
}

const IconSort = (props: IProps) => (
  <svg
    style={{
      width: `${props.size}px`,
      height: `${props.size}px`,
    }}
    viewBox="0 0 12 12"
    fill="none"
    stroke={props.color}
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {props.direction !== 'down' && <path d="M3.5 4.5 6 2l2.5 2.5" />}
    {props.direction !== 'up' && <path d="M3.5 7.5 6 10l2.5-2.5" />}
  </svg>
)

export default IconSort
